export class recycleBinUrl {
    DELETE_RECYCLE_BIN_URL = "sig/v1/recycle-bin/";
    RECYCLE_BIN_URL = "sig/v1/recycle-bin/all[?ClientName][&ClientId][&Subject][&DocumentType][&TaxYear][&Recipients][&Status][&DeletedBy][&DeletionDate][&SortBy][&SortOrder][&PageNumber][&PageSize]";
    RESTORE_RECYCLE_BIN_URL = "sig/v1/recycle-bin/";
}

